"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNodeValues = exports.getParentNodeID = exports.findDateFromString = exports.getNodeSubtitle = exports.getNodeLevelTitle = exports.getLayouts = exports.getCategories = exports.getDates = void 0;
const lodash_1 = __importDefault(require("lodash"));
const utilities_1 = require("../../../utilities");
const date_1 = require("../../../utilities/date");
const PADDING = 3;
const nodeValueById = (links, data, id, category, date) => {
  const matchingLinks = lodash_1.default.filter(links, _ref => {
    let {
      target
    } = _ref;
    return target === id;
  });
  const linkData = (0, lodash_1.default)(matchingLinks).map(_ref2 => {
    let {
      metrics
    } = _ref2;
    const {
      id: categoryID
    } = lodash_1.default.find(metrics, _ref3 => {
      let {
        name
      } = _ref3;
      return name === category;
    }) || {};
    if (categoryID === undefined) {
      return undefined;
    }
    const categoryData = lodash_1.default.find(data, datum => datum.id === categoryID);
    return getDataValueByDate(categoryData, date);
  }).compact().value();
  return lodash_1.default.sum(linkData);
};
// eslint-disable-next-line camelcase
const getDataValueByDate = function () {
  let {
    data,
    x_type
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (lodash_1.default.isArray(data) && lodash_1.default.isDate(date)) {
    const {
      value
    } = lodash_1.default.find(data, _ref4 => {
      let {
        key
      } = _ref4;
      const keyDate = (0, date_1.dateParser)(key, x_type);
      return keyDate.getTime() === date.getTime();
    }) || {};
    return value;
  }
  return null;
};
const availableWidth = (levels, width) => {
  if (!levels || !width || width <= 0) return 0;
  if (levels[0].nodes.length === 1) return width;
  return width - PADDING * (levels[0].nodes.length - 1);
};
const getLinkPosition = function (linkWidth, nodePositions, source, target, color) {
  let sourceAcc = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  let targetAcc = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  const sourceNode = lodash_1.default.find(nodePositions, _ref5 => {
    let {
      id
    } = _ref5;
    return id === source;
  });
  const targetNode = lodash_1.default.find(nodePositions, _ref6 => {
    let {
      id
    } = _ref6;
    return id === target;
  });
  const settingColors = color === 'target' ? targetNode.color : color;
  return {
    position: {
      color: settingColors || sourceNode.color || targetNode.color,
      bottomLeft: {
        x: targetAcc,
        y: targetNode.y
      },
      bottomRight: {
        x: targetAcc + linkWidth,
        y: targetNode.y
      },
      id: `${source}|${target}`,
      source,
      target,
      topLeft: {
        x: sourceAcc,
        y: sourceNode.y + sourceNode.height
      },
      topRight: {
        x: sourceAcc + linkWidth,
        y: sourceNode.y + sourceNode.height
      }
    },
    sourceAcc: sourceAcc + linkWidth,
    targetAcc: targetAcc + linkWidth
  };
};
const getLinkPositions = (levels, links, data, nodePositions, width, category, date) => {
  const positions = {};
  const accBySource = {};
  const accByTarget = {};
  links
  // filter out "top level links" with no source
  .filter(_ref7 => {
    let {
      source,
      target
    } = _ref7;
    return source && target;
  }).forEach(_ref8 => {
    let {
      source,
      target,
      color,
      metrics
    } = _ref8;
    const sourceNode = lodash_1.default.find(nodePositions, _ref9 => {
      let {
        id
      } = _ref9;
      return id === source;
    });
    const targetNode = lodash_1.default.find(nodePositions, _ref10 => {
      let {
        id
      } = _ref10;
      return id === target;
    });
    if (lodash_1.default.isNil(sourceNode) || lodash_1.default.isNil(targetNode)) {
      return;
    }
    if (!accBySource[source]) {
      accBySource[source] = sourceNode.x;
    }
    if (!accByTarget[target]) {
      accByTarget[target] = targetNode.x;
    }
    const {
      id: categoryID
    } = lodash_1.default.find(metrics, _ref11 => {
      let {
        name
      } = _ref11;
      return name === category;
    }) || {};
    const categoryData = lodash_1.default.find(data, _ref12 => {
      let {
        id
      } = _ref12;
      return id === categoryID;
    });
    const linkValue = getDataValueByDate(categoryData, date);
    const linkWidth = availableWidth(levels, width) * linkValue;
    const {
      position,
      sourceAcc,
      targetAcc
    } = getLinkPosition(linkWidth, nodePositions, source, target, color, accBySource[source], accByTarget[target]);
    positions[`${source}|${target}`] = position;
    accBySource[source] = sourceAcc;
    accByTarget[target] = targetAcc;
  });
  return positions;
};
const getNodeLayout = function () {
  let {
    id,
    color,
    label
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let nodeWidth = arguments.length > 1 ? arguments[1] : undefined;
  let nodeHeight = arguments.length > 2 ? arguments[2] : undefined;
  let linkHeight = arguments.length > 3 ? arguments[3] : undefined;
  let level = arguments.length > 4 ? arguments[4] : undefined;
  let marginY = arguments.length > 5 ? arguments[5] : undefined;
  let accX = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  return {
    layout: {
      id,
      color,
      label: lodash_1.default.isNil(label) ? '' : label,
      x: accX,
      y: marginY + level * (nodeHeight + linkHeight),
      width: nodeWidth,
      height: nodeHeight
    },
    acc: accX + nodeWidth + PADDING
  };
};
const getNodeLayouts = (levels, links, nodes, data, width, nodeHeight, linkHeight, marginX, marginY, category, date) => {
  const layouts = [];
  levels.forEach((_ref13, i) => {
    let {
      nodes: levelNodes
    } = _ref13;
    let x = marginX;
    levelNodes.forEach(id => {
      const nodeValue = nodeValueById(links, data, id, category, date);
      const nodeWidth = availableWidth(levels, width) * nodeValue;
      const node = nodes.find(_ref14 => {
        let {
          id: nodeID
        } = _ref14;
        return id === nodeID;
      });
      const {
        layout,
        acc
      } = getNodeLayout(node, nodeWidth, nodeHeight, linkHeight, i, marginY, x);
      layouts.push(layout);
      x = acc;
    });
  });
  return layouts;
};
const getDates = data => (0, date_1.intersectingDates)(data);
exports.getDates = getDates;
const getCategories = links => {
  const allKeys = (0, lodash_1.default)(links).map(_ref15 => {
    let {
      metrics = []
    } = _ref15;
    return metrics.map(_ref16 => {
      let {
        name
      } = _ref16;
      return name;
    });
  }).compact();
  return lodash_1.default.intersectionBy(...allKeys);
};
exports.getCategories = getCategories;
const getLayouts = function (data, levels, links, nodes, width, nodeHeight, linkHeight, category, date) {
  let levelLabelsWidth = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
  let {
    top = 20,
    left = 0,
    right = 0,
    bottom = 0
  } = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : {};
  const dates = (0, date_1.intersectingDates)(data);
  const {
    key: dateKey
  } = dates.find(_ref17 => {
    let {
      formatted
    } = _ref17;
    return date === formatted;
  }) || {};
  if (!category || !date || !dateKey) {
    return {
      nodes: [],
      links: [],
      levels: []
    };
  }
  const marginX = levelLabelsWidth + left;
  const marginY = top + bottom;
  const nodesWidth = width - marginX - right;
  const nodePositions = getNodeLayouts(levels, links, nodes, data, nodesWidth, nodeHeight, linkHeight, marginX, marginY, category, dateKey);
  return {
    nodes: nodePositions,
    links: getLinkPositions(levels, links, data, nodePositions, nodesWidth, category, dateKey),
    levels: levels.map((_ref18, i) => {
      let {
        title,
        label,
        nodes
      } = _ref18;
      return {
        title,
        label,
        y: marginY + i * (nodeHeight + linkHeight),
        x: left,
        width: (0, lodash_1.default)(nodes).map(node => {
          const nodePosition = lodash_1.default.find(nodePositions, _ref19 => {
            let {
              id
            } = _ref19;
            return id === node;
          }) || {};
          if (lodash_1.default.isNaN(nodePosition.x) || lodash_1.default.isNaN(nodePosition.width)) {
            return null;
          }
          return nodePosition.x + nodePosition.width;
        }).max() - left,
        height: nodeHeight
      };
    })
  };
};
exports.getLayouts = getLayouts;
const getNodeLevelTitle = function () {
  let nodeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let levels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (nodeID === null) {
    return '';
  }
  let levelIndex = levels.findIndex(_ref20 => {
    let {
      nodes = []
    } = _ref20;
    return nodes.find(node => node === nodeID);
  });
  if (levelIndex === -1) {
    return '';
  }
  let {
    title
  } = levels[levelIndex];
  while (levelIndex > 0 && title === undefined) {
    levelIndex -= 1;
    title = levels[levelIndex].title;
  }
  return title;
};
exports.getNodeLevelTitle = getNodeLevelTitle;
const getNodeSubtitle = function () {
  let nodeID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let nodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  let levels = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  if (nodeID === null || category === null) {
    return '';
  }
  const node = nodes.find(_ref21 => {
    let {
      id
    } = _ref21;
    return id === nodeID;
  });
  const level = levels.find(_ref22 => {
    let {
      nodes = []
    } = _ref22;
    return nodes.find(node => node === nodeID);
  });
  const {
    label: nodeLabel = ''
  } = node || {};
  const {
    label: levelLabel = ''
  } = level || {};
  return `${levelLabel} ${nodeLabel}, ${category}`;
};
exports.getNodeSubtitle = getNodeSubtitle;
const findDateFromString = function () {
  let dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let dateString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!Array.isArray(dates)) {
    return null;
  }
  const date = lodash_1.default.find(dates, _ref23 => {
    let {
      formatted
    } = _ref23;
    return dateString === formatted;
  });
  const {
    key
  } = date || {};
  return key;
};
exports.findDateFromString = findDateFromString;
const getParentNodeID = function (nodeID) {
  let links = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (nodeID === null) {
    return null;
  }
  const sourceLink = lodash_1.default.find(links, _ref24 => {
    let {
      target
    } = _ref24;
    return target === nodeID;
  }) || {};
  return sourceLink.source;
};
exports.getParentNodeID = getParentNodeID;
const getNodeValues = function (nodeID, date) {
  let links = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  let data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  const {
    metrics
  } = lodash_1.default.find(links, _ref25 => {
    let {
      target
    } = _ref25;
    return target === nodeID;
  }) || {};
  if (nodeID === undefined || date === undefined || metrics === undefined) {
    return [];
  }
  return (0, lodash_1.default)(metrics).map(_ref26 => {
    let {
      name,
      id,
      unit
    } = _ref26;
    const datum = data.find(_ref27 => {
      let {
        id: dataID
      } = _ref27;
      return id === dataID;
    });
    // eslint-disable-next-line camelcase
    const {
      y_type,
      x_type,
      data: values = []
    } = datum || {};
    const {
      value
    } = lodash_1.default.find(values, _ref28 => {
      let {
        key
      } = _ref28;
      const keyDate = (0, date_1.dateParser)(key, x_type);
      if (keyDate instanceof Date && date instanceof Date) {
        return keyDate.getTime() === date.getTime();
      }
      return null;
    }) || {};
    return {
      name,
      value,
      unit,
      format: y_type,
      formattedValue: (0, utilities_1.valueFormat)({
        params: {
          format: y_type
        }
      })(value)
    };
  }).value();
};
exports.getNodeValues = getNodeValues;